// This file was automatically generated from appchart.refpanel.family.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.refpanel.family');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.family.relationshipBlock = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FieldShortLabelPadding relative mb5"><label class="el8label el8LHSSubLabelGray"><a class="el8RemoveItemButton remove-relationship-trigger" data-id="', soy.$$escapeHtml(opt_data.relationshipId), '"></a>', soy.$$escapeHtml(opt_data.relationshipName), ':</label><div class="el8FieldLongLabelPadding"><ol class="structured-family-history-', soy.$$escapeHtml(opt_data.relationshipId), '" data-id="', soy.$$escapeHtml(opt_data.relationshipId), '"></ol></div></div>');
  if (!opt_sb) return output.toString();
};
